export default "__VITE_ASSET__DYgHqDZP__"